import { Device, FirebaseAnalytics } from "./plugins";
import { catchErrorWithStack } from "./crashlytics";
import store from "./store";
import { IS_WEB, PLATFORM } from "./config";
import { runAfterNextRepaint } from "./utils";
import { FIREBASE_CONFIG } from "./firebase";
import { GAME_MODE_INV, gameState } from "./game/gameState";
import { yieldWithPriority } from "./promise";
import { getLogger } from "./logging";

let gDidInit = false;

const log = getLogger("📊 Analytics")

export async function initAnalytics() {
  if (IS_WEB) {
    try {
      await FirebaseAnalytics.initializeFirebase(FIREBASE_CONFIG);
      if (window.gtag)
        window.gtag("config", FIREBASE_CONFIG.measurementId, {
          cookie_flags: "max-age=7200;secure;sameSite=none",
        });
      else throw new Error("gtag not found");
      log.debug("Initialized Firebase");
    } catch (error) {
      return catchErrorWithStack(error);
    }
  }
  if (gDidInit) {
    log.warn("Analytics did already init");
    return;
  }
  try {
    await FirebaseAnalytics.setCollectionEnabled({
      enabled: true,
    });
    const { identifier } = await Device.getId();
    await Promise.all([
      FirebaseAnalytics.setUserId({
        userId: store.user.uid || identifier,
      }),
      FirebaseAnalytics.setUserProperty({
        name: "language",
        value: navigator.language || navigator.userLanguage,
      }),
      FirebaseAnalytics.setUserProperty({
        name: "deviceId",
        value: identifier,
      }),
    ]);
    gDidInit = true;
  } catch (error) {
    catchErrorWithStack(error);
  }
}

export async function setScreenName(screenName) {
  log.debug(`Screen name ${screenName} <- ${store.screenName}`);
  store.screenNamePrev = store.screenName;
  store.set("screenName", screenName);
  await yieldWithPriority("background");
  try {
    await FirebaseAnalytics.setScreenName({ screenName });
  } catch (error) {
    catchErrorWithStack(error);
  }
}

export async function logEvent(name, params = null) {
  await yieldWithPriority("background");
  if (params == null) params = getEventParams();
  try {
    if (__DEV__) log.debug("Event", name, params);
    runAfterNextRepaint(FirebaseAnalytics.logEvent, {
      name,
      params,
    });
  } catch (error) {
    catchErrorWithStack(error);
  }
}

export function getEventParams() {
  return {
    levelIdx: store.levelIdx,
    maxLevelIdx: store.maxLevelIdx,
    disableMusic: store.disableMusic,
    step: store.step,
    secondsPassed: store.secondsPassed,
    appVersion: store.appVersion,
    appVersionPrev: store.appVersionPrev,
    numLives: store.numLives,
    platform: PLATFORM,
    loggedIn: !!store.user.uid,
  };
}

export function getGameEventParams() {
  return {
    mode: GAME_MODE_INV[gameState.mode],
  };
}

if (__DEV__) window.logEvent = logEvent;
